import {
	REQUEST_PROMO_BEGIN,
	REQUEST_PROMO_SUCCESS,
	REQUEST_PROMO_FAILURE,
} from '../actions/requestPromoActions'

const initialState = {
	reservation: [],
	loading: false,
	error: null,
}

export default function getPromoReducers(state = initialState, action) {
	switch(action.type) {
		case REQUEST_PROMO_BEGIN:
			// Request begin: set loading true and pass urlData to state
			return {
				...state,
				loading: true,
				error: null,
			}

		case REQUEST_PROMO_SUCCESS:
			// Request success: set loading false, and display request data
			return {
				...state,
				loading: false,
				reservation: action.payload,
			}

		case REQUEST_PROMO_FAILURE:
			// Request failed: set loading false, save & display error
			return {
				...state,
				loading: false,
				error: action.payload.error,
				reservation: [],
			}

		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/reducers/requestPromoReducers.js